import { useQuery } from "react-query";
import auditLogsService from "../../services/auditLogsService";
import {
  getCachedAllUsers,
  cacheAllUsers,
} from "../../pages/AuditLogs/UserCache";

export const useListAuditLogs = ({ params }) => {
  return useQuery(
    ["listAuditLogs", params],
    () => auditLogsService.listAuditLogs({ params }),
    {
      enabled: params?.run || false,
      keepPreviousData: true,
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

export const useListMsplogisticAuditLogs = ({ params }) => {
  return useQuery(
    ["listMsplogisticAuditLogs", params],
    () => auditLogsService.listMsplogisticAuditLogs({ params }),
    {
      enabled: params?.run || false,
      keepPreviousData: true,
      select: response => {
        const { data } = response || {};
        return {
          items: data?.items || [],
          totalCount: data?._meta?.totalCount || 0,
        };
      },
    }
  );
};
export const useCustomerAuditLogs = ({
  customerCode,
  enabled = false,
  params = {
    page: 1,
    sizePerPage: 10,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
  },
}) => {
  const {
    page = 1,
    sizePerPage = 10,
    sort = "-maker_date",
    columnFilter = {},
    keywords = "",
  } = params;

  return useQuery(
    ["customerAuditLogs", customerCode, params],
    () =>
      auditLogsService.listMsplogisticAuditLogs({
        params: {
          page,
          sizePerPage,
          sort,
          keywords,
          columnFilter: {
            "filter[tracking_key]": customerCode,
            ...columnFilter,
          },
          run: true,
        },
      }),
    {
      enabled: Boolean(enabled && customerCode),
      keepPreviousData: true,
      select: response => {
        const { data } = response || {};
        return {
          items: data?.items || [],
          totalCount: data?._meta?.totalCount || 0,
        };
      },
    }
  );
};
export const useLogAdminUsers = () => {
  return useQuery(
    ["logAdminUsers"],
    async () => {
      const cachedUsers = getCachedAllUsers();
      if (cachedUsers) {
        return cachedUsers;
      }

      const response = await auditLogsService.listMsplogisticUsers({
        params: {
          page: -1,
          sizePerPage: 1000,
          sort: "-maker_date",
          keywords: "",
          expand: "maker,checker",
          fields: "",
          columnFilter: {
            "filter[record_status]": "O",
          },
        },
      });
      cacheAllUsers(response);
      return response;
    },
    {
      enabled: true,
      keepPreviousData: true,
      select: response => {
        const { data } = response || {};
        return {
          items: data?.items || [],
          totalCount: data?._meta?.totalCount || 0,
        };
      },
    }
  );
};
export const useTransportLocalitiesAuditLogs = ({
  type,
  enabled = false,
  params = {
    page: 1,
    sizePerPage: 10,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
  },
}) => {
  const {
    page = 1,
    sizePerPage = 10,
    sort = "-maker_date",
    columnFilter = {},
    keywords = "",
  } = params;

  return useQuery(
    ["transportLocalitiesAuditLogs", type, params],
    () =>
      auditLogsService.listMsplogisticAuditLogs({
        params: {
          page,
          sizePerPage,
          sort,
          keywords,
          columnFilter: {
            "filter[type]": type,
            ...columnFilter,
          },
          run: true,
        },
      }),
    {
      enabled: Boolean(enabled && type),
      keepPreviousData: true,
      select: response => {
        const { data } = response || {};
        return {
          items: data?.items || [],
          totalCount: data?._meta?.totalCount || 0,
        };
      },
    }
  );
};
export const useLogTransportLocalitiesUsers = () => {
  return useQuery(
    ["logTransportLocalitiesUsers"],
    () =>
      auditLogsService.listMsplogisticUsers({
        params: {
          page: -1,
          sizePerPage: 1000,
          sort: "-maker_date",
          keywords: "",
          expand: "maker,checker",
          fields: "",
          columnFilter: {
            "filter[record_status]": "O",
            "filter[user_type]": "1",
          },
        },
      }),
    {
      enabled: true,
      keepPreviousData: true,
      select: response => {
        const { data } = response || {};
        return {
          items: data?.items || [],
          totalCount: data?._meta?.totalCount || 0,
        };
      },
    }
  );
};
